import { render, staticRenderFns } from "./JewelleryType.vue?vue&type=template&id=a3042caa"
import script from "./JewelleryType.vue?vue&type=script&lang=js"
export * from "./JewelleryType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports